const EntryDetailsCard = ({
  form,
  setForm,
  sites,
  departments,
  activityTypes,
  reportingYear,
  onActivityChange,
  errors = {}
}) => {

  // =========================
  // LOCATION CHANGE
  // =========================

  const handleLocationChange = (e) => {

    const selectedId = e.target.value;

    const selectedSite =
      sites.find(
        (s) =>
          String(s.site_id)
          ===
          String(selectedId)
      );

    setForm({
      ...form,
      location_id: selectedId,
      legal_entity:
        selectedSite?.legal_entity
        ||
        selectedSite?.entity_name
        ||
        ""
    });
  };

  return (

    <div className="le-card ecf-card">

      <div className="org-form-section-title">
        + Entry Details
      </div>

      {/* ROW 1 */}

      <div className="org-form-row ecf-grid-3">

        {/* REPORTING YEAR */}

        <div className="org-form-field">

          <div className="ecf-field-label-row">

            <label className="org-field-label">
              Reporting Year
              <span className="req"> *</span>
            </label>

            <span className="ecf-label-tag">
              From Config
            </span>

          </div>

          <input
            type="text"
            className="org-field-input ecf-input-disabled"
            value={reportingYear || ""}
            disabled
          />

        </div>

        {/* LOCATION */}

        <div className="org-form-field">

          <label className="org-field-label">
            Location
            <span className="req"> *</span>
          </label>

          <select
            className={`org-field-input ${
              errors.location_id
                ? "org-field-input--error"
                : ""
            }`}
            value={form.location_id}
            onChange={handleLocationChange}
          >

            <option value="">
              Select Location
            </option>

            {sites.map((site) => (

              <option
                key={site.site_id}
                value={site.site_id}
              >
                {site.site_name}
              </option>

            ))}

          </select>

          {errors.location_id && (

            <div className="org-field-error">
              {errors.location_id}
            </div>

          )}

        </div>

        {/* LEGAL ENTITY */}

        <div className="org-form-field">

          <label className="org-field-label">
            Legal Entity
            <span className="req"> *</span>
          </label>

          <input
            type="text"
            className={`org-field-input ecf-input-disabled ${
              errors.legal_entity
                ? "org-field-input--error"
                : ""
            }`}
            value={form.legal_entity || ""}
            placeholder="Select location first"
            disabled
          />

          {errors.legal_entity && (

            <div className="org-field-error">
              {errors.legal_entity}
            </div>

          )}

        </div>

      </div>

      {/* ROW 2 */}

      <div className="org-form-row ecf-grid-3 ecf-row-gap">

        {/* DEPARTMENT */}

        <div className="org-form-field">

          <div className="ecf-field-label-row">

            <label className="org-field-label">
              Department
            </label>

            <span className="ecf-label-tag">
              Optional
            </span>

          </div>

          <select
            className="org-field-input"
            value={form.department_id}
            onChange={(e) =>
              setForm({
                ...form,
                department_id: e.target.value
              })
            }
          >

            <option value="">
              Select Department
            </option>

            {departments.map((dept) => (

              <option
                key={dept.department_id}
                value={dept.department_id}
              >
                {dept.department_name}
              </option>

            ))}

          </select>

        </div>

        {/* DATE */}

        <div className="org-form-field">

          <label className="org-field-label">
            Date
            <span className="req"> *</span>
          </label>

          <input max={new Date().toISOString().split("T")[0]}
            type="date"
            className={`org-field-input ${
              errors.record_date
                ? "org-field-input--error"
                : ""
            }`}
            value={form.record_date}
            onChange={(e) =>
              setForm({
                ...form,
                record_date: e.target.value
              })
            }
          />

          {errors.record_date && (

            <div className="org-field-error">
              {errors.record_date}
            </div>

          )}

        </div>

        {/* ACTIVITY TYPE */}

        <div className="org-form-field">

          <label className="org-field-label">
            Activity Type
            <span className="req"> *</span>
          </label>

          <select
            className={`org-field-input ${
              errors.activity_type_id
                ? "org-field-input--error"
                : ""
            }`}
            value={form.activity_type_id}
            onChange={onActivityChange}
          >

            <option value="">
              Select Activity
            </option>

            {activityTypes.map((activity) => (

              <option
                key={activity.id}
                value={activity.id}
              >
                {activity.name}
              </option>

            ))}

          </select>

          {errors.activity_type_id && (

            <div className="org-field-error">
              {errors.activity_type_id}
            </div>

          )}

        </div>

      </div>

    </div>
  );
};

export default EntryDetailsCard;